/** Who may open the main screens the background warm fills, stated once so the
 *  screen mounts in AuthenticatedWorkspace and the warm cannot drift apart: a
 *  warm for a screen its person cannot open only buys a 403. */

import { isInternalRole } from '../../utils/permissions';
import type { UserRole } from '../../types/auth';

export interface ScreenAccessAuth {
  isAdmin(): boolean;
  isStaff(): boolean;
  isSuperAdmin(): boolean;
  isInternal(): boolean;
  user?: { role?: string } | null;
}

interface NavigationState {
  authoritative: boolean;
  navigation: { main: ReadonlyArray<{ id: string }> } | null;
}

/** With server grants only a granted destination opens, and none does while they load. */
export function navigationGranted(state: NavigationState, destination: string): boolean {
  return !state.authoritative || state.navigation?.main.some(item => item.id === destination) === true;
}

/** The finance hubs: Accounting, Sales, Purchases, Payroll, Tax and CIS Returns. */
export function canOpenFinanceHubs(auth: ScreenAccessAuth): boolean {
  return auth.isAdmin() || auth.isStaff() || auth.user?.role === 'workspace_owner' || auth.user?.role === 'workspace_admin';
}

/** Email, and the shared inboxes drawn inside it. */
export function canOpenEmail(auth: ScreenAccessAuth): boolean {
  return auth.isSuperAdmin() || auth.isInternal();
}

/** The workspace directory, with its credit and subscription columns. */
export function canOpenWorkspaceDirectory(auth: ScreenAccessAuth): boolean {
  return auth.isInternal();
}

// Not isAdmin(): that admits the customer-side `admin` account holder.
export function canOpenOutreach(auth: ScreenAccessAuth): boolean {
  return isInternalRole(auth.user?.role as UserRole | undefined);
}
